module.exports = __webpack_public_path__ + "static/img/view-primary.f46bb34a.svg";